/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
export enum LeadStatus {
    // Lead statuses
    New = "new",
    ContactAttempt = "contact_attempt",
    Contacted = "contacted",
	Qualified = "qualified",
	Disqualified = "disqualified",
	OpportunityCreated = "opportunity_created",
    NewInquiry = "new_inquiry",
    IndicativeOffer = "indicative_offer",
    OnlineBooked = "online_booked",
    Quotation = "offer",
    Acceptance = "accepted",
    Finished = "finished",
    OnHold = "on_hold",
    Rejection = "declined",
}

export enum LeadStatusViewDefault {
		All= "all"
}

export type LeadStatusView = LeadStatus | LeadStatusViewDefault;